import React, { useEffect, useState } from 'react';

export function ThemeIconImg({ src, alt, fallback, className = '' }) {
  const [failed, setFailed] = useState(false);
  useEffect(() => {
    setFailed(false);
  }, [src]);
  const cls = ['theme-icon-img', className].filter(Boolean).join(' ');
  if (src && !failed) {
    return (
      <img
        src={src}
        alt={alt || ''}
        className={cls}
        loading="lazy"
        decoding="async"
        onError={() => setFailed(true)}
      />
    );
  }
  return <span className={cls}>{fallback}</span>;
}
